import { useEffect, useState } from 'react';
import { Input, MessagePlugin } from 'tdesign-react';

import { Edit } from '@/components/icon';
import { getUnicodeLength } from '@/utils/getUnicodeLength';

import styles from './index.module.less';

interface IProps {
  value: string;
  onChange: (name: string) => void;
  disabled?: boolean;
  style?: React.CSSProperties;
}

const MAX_LENGTH = 20;

const Rename: React.FC<IProps> = (props) => {
  const { value, disabled = false, onChange } = props;
  const [name, setName] = useState('');
  const [editing, setEditing] = useState(false);
  const [focus, setFocus] = useState(false);

  useEffect(() => {
    setName(value || '未命名');
  }, [value]);

  useEffect(() => () => {
    setName('');
    onClose();
  }, []);

  const onClose = () => {
    setEditing(false);
    setFocus(false);
  };

  const onOpen = (e: React.MouseEvent) => {
    if (disabled) {
      return;
    }
    e.stopPropagation();
    setEditing(true);
  };

  const onBlur = () => {
    const newName = name?.trim() || '';
    if (newName === '') {
      MessagePlugin.error('名称不能为空');
      setName(value || '未命名');
      return;
    }
    if (getUnicodeLength(newName) > MAX_LENGTH) {
      MessagePlugin.error(`名称长度不能超过${MAX_LENGTH}`);
      setName(value || '未命名');
      return;
    }
    onChange(newName);
    onClose();
  };

  useEffect(() => {
    const handleClick = () => {
      if (editing) {
        onClose();
      }
    };

    document.addEventListener('click', handleClick);
    return () => {
      document.removeEventListener('click', handleClick);
    };
  }, [editing]);

  return (
    <span className={styles.content} style={props.style}>
      {editing
        ? <Input
            className={styles.content}
            style={props.style}
            value={name}
            allowInputOverMax
            onBlur={onBlur}
            onFocus={() => setFocus(true)}
            onChange={v => setName(v)}
            onClick={({ e }) => e.stopPropagation()}
            maxlength={focus ? MAX_LENGTH : undefined}
            showLimitNumber
            placeholder="请输入新名称"
          />
        : <div className={styles.title}>
            <span
              className={styles.name}
              onDoubleClick={(e: React.MouseEvent<HTMLSpanElement>) => onOpen(e)}
            >
              {name}
            </span>
          {!disabled && <Edit onClick={(e: React.MouseEvent<SVGSVGElement>) => onOpen(e)} />}
          </div>
      }
    </span>
  );
};

export default Rename;
